'use strict';
const Joi = require('joi');
const errorHandler = require('../helpers/error-handler');

class PartnerCredentials {
  constructor(credentials) {
    this.Credentials = this.validateCredentials(credentials);
  }

  getCredentials() {
    if (this.Credentials) {
      return this.Credentials;
    }
    throw errorHandler.handleError('Credentials are not set');
  }

  validateCredentials(credentials) {
    this.schema = Joi.object().keys({
      domain: Joi.string().required(),
      clientId: Joi.string().required(),
      userName: Joi.string().required(),
      password: Joi.string().required(),
    });
    return Joi.validate(credentials, this.schema, (err, validCredentials) => {
      if (err) {
        throw errorHandler.handleError('Error validating credentials ' + err.details[0].message);
      } else {
        return validCredentials;
      }
    });

  }

}

module.exports = PartnerCredentials;
